<template>
    <div class="header ">
        <nav class="sticky top-0 z-50 w-full bg-white border-b border-gray-200">
            <div class="flex flex-wrap justify-between items-center py-4 px-6">
                <div id="tutorial_setup_logo">
                    <router-link to="/employer/dashboard" class="flex items-center">
                        <img src="../../../assets/images/logo.png" class="h-8 mr-3" alt="Logo" />
                    </router-link>
                </div>
                <div class="flex">
                    <button type="button" class="font-medium mr-10">
                        Check-In
                    </button>
                    <button type="button" class="font-medium mr-10">
                        Ask a question
                    </button>

                    <button type="button" class="font-medium mr-10" @click="handleClick">Site Tutorial</button>

                    <button data-collapse-toggle="mega-menu-full" type="button"
                        class="inline-flex items-center p-2 ml-1 text-sm text-gray-500 rounded-lg md:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600"
                        aria-controls="mega-menu-full" aria-expanded="false">
                        <span class="sr-only">Open main menu</span>
                        <svg class="w-6 h-6" aria-hidden="true" fill="currentColor" viewBox="0 0 20 20"
                            xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd"
                                d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
                                clip-rule="evenodd"></path>
                        </svg>
                    </button>

                    <div id="mega-menu-full"
                        class="items-center justify-between font-medium hidden w-full md:flex md:w-auto md:justify-between">
                        <ul
                            class="flex flex-col p-4 md:p-0 mt-4 border border-blue-800 rounded-lg md:flex-row md:space-x-8 md:mt-0 md:border-0 md:bg-white">
                            <li class="outline outline-offset-2 outline-1 rounded">
                                <router-link to="/employer/request-workshop"
                                    class="flex items-center p-2 text-gray-900 rounded-lg">
                                    <svg width="20" height="21" viewBox="0 0 20 21" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <g clip-path="url(#clip0_5367_103)">
                                            <path
                                                d="M8.33334 11.3118C8.33334 11.7538 8.50894 12.1778 8.8215 12.4903C9.13406 12.8029 9.55798 12.9785 10 12.9785C10.442 12.9785 10.866 12.8029 11.1785 12.4903C11.4911 12.1778 11.6667 11.7538 11.6667 11.3118C11.6667 10.8698 11.4911 10.4459 11.1785 10.1333C10.866 9.82074 10.442 9.64514 10 9.64514C9.55798 9.64514 9.13406 9.82074 8.8215 10.1333C8.50894 10.4459 8.33334 10.8698 8.33334 11.3118Z"
                                                stroke="#0A0346" stroke-width="1.5" stroke-linecap="round"
                                                stroke-linejoin="round" />
                                            <path
                                                d="M6.66666 17.9785V17.1452C6.66666 16.7032 6.84225 16.2792 7.15481 15.9667C7.46737 15.6541 7.8913 15.4785 8.33332 15.4785H11.6667C12.1087 15.4785 12.5326 15.6541 12.8452 15.9667C13.1577 16.2792 13.3333 16.7032 13.3333 17.1452V17.9785"
                                                stroke="#0A0346" stroke-width="1.5" stroke-linecap="round"
                                                stroke-linejoin="round" />
                                            <path
                                                d="M12.5 4.64518C12.5 5.08721 12.6756 5.51113 12.9882 5.82369C13.3007 6.13625 13.7246 6.31185 14.1667 6.31185C14.6087 6.31185 15.0326 6.13625 15.3452 5.82369C15.6577 5.51113 15.8333 5.08721 15.8333 4.64518C15.8333 4.20315 15.6577 3.77923 15.3452 3.46667C15.0326 3.15411 14.6087 2.97852 14.1667 2.97852C13.7246 2.97852 13.3007 3.15411 12.9882 3.46667C12.6756 3.77923 12.5 4.20315 12.5 4.64518Z"
                                                stroke="#0A0346" stroke-width="1.5" stroke-linecap="round"
                                                stroke-linejoin="round" />
                                            <path
                                                d="M14.1667 8.81189H15.8333C16.2754 8.81189 16.6993 8.98748 17.0118 9.30005C17.3244 9.61261 17.5 10.0365 17.5 10.4786V11.3119"
                                                stroke="#0A0346" stroke-width="1.5" stroke-linecap="round"
                                                stroke-linejoin="round" />
                                            <path
                                                d="M4.16666 4.64518C4.16666 5.08721 4.34225 5.51113 4.65481 5.82369C4.96737 6.13625 5.3913 6.31185 5.83332 6.31185C6.27535 6.31185 6.69927 6.13625 7.01183 5.82369C7.32439 5.51113 7.49999 5.08721 7.49999 4.64518C7.49999 4.20315 7.32439 3.77923 7.01183 3.46667C6.69927 3.15411 6.27535 2.97852 5.83332 2.97852C5.3913 2.97852 4.96737 3.15411 4.65481 3.46667C4.34225 3.77923 4.16666 4.20315 4.16666 4.64518Z"
                                                stroke="#0A0346" stroke-width="1.5" stroke-linecap="round"
                                                stroke-linejoin="round" />
                                            <path
                                                d="M2.5 11.3119V10.4786C2.5 10.0365 2.67559 9.61261 2.98816 9.30005C3.30072 8.98748 3.72464 8.81189 4.16667 8.81189H5.83333"
                                                stroke="#0A0346" stroke-width="1.5" stroke-linecap="round"
                                                stroke-linejoin="round" />
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_5367_103">
                                                <rect width="20" height="20" fill="white"
                                                    transform="translate(0 0.478516)" />
                                            </clipPath>
                                        </defs>
                                    </svg>


                                    <span id="tutorial_setup_custom-wr"
                                        class="flex-1 text-[#0A0446] ml-3 whitespace-nowrap">Custom Workshop
                                        Requests</span>
                                </router-link>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </nav>
    </div>
</template>
<script>
/* eslint-disable */
import AppMixin from '../../../mixins/AppMixin'


export default {
    name: "Header",
    props: ['userProp'],
    data() {
        return {
        }
    },
    mixins: [AppMixin],
    methods:
    {
        handleClick() {
            // const pathname = window.location.pathname;
            // console.log(pathname,"path");
            window.localStorage.removeItem('window-driver');
            const baseUrl = window.location.origin;
            window.location.href = baseUrl + "/employer/dashbaord";
        }
    },
    created() {

    },
}
</script>


// WEBPACK FOOTER //
// src/components/employer/includes/Header.vue